import React from "react";
import InventoryIcon from "@mui/icons-material/Inventory";
import { useGetAssetsItemsPermissions } from "@features/unified-side-nav-feature/hooks/useGetAssetsNavPermission";
import { shiOneUrl } from "@constants";


const assetsDashboard: string = "/assets-dashboard";
const assetsLifecycleManagement: string = "/assets/lifecycle-management";
const assetsPurchasedAssets: string = "/assets/purchased-assets";
const assetsDiscoveredAssets: string = "/assets/discovered-assets";
const assetsIntegrationCenter: string = "/assets/integration-center";
const assetsCiscoInstallBaseAnalysis: string = "/assets/cisco-install-base-analysis";

export function useGetAssetsNavItems() {

  const { showAssetsSection, assetsItems } = useGetAssetsItemsPermissions();

  return [
    {
      id: "assets",
      type: "Dashboard",
      displayName: "Assets",
      visible: showAssetsSection,
      icon: <InventoryIcon />,
      path: assetsDashboard,
      children: [
        {
          id: "assets-lifecycle",
          type: "Link",
          displayName: "Lifecycle Management",
          visible: Boolean(assetsItems.showAssetLifecycleManagement),
          path: assetsLifecycleManagement,
        },
        {
          id: "assets-purchased",
          type: "Link",
          displayName: "Purchased Assets",
          visible: Boolean(assetsItems.showPurchasedAssets),
          path: assetsPurchasedAssets,
        },
        {
          id: "assets-discovered",
          type: "Link",
          displayName: "Discovered Assets",
          visible: Boolean(assetsItems.showDiscoveredAssets),
          path: assetsDiscoveredAssets,
        },
        {
          id: "assets-managed",
          type: "Link",
          displayName: "Managed Assets",
          visible: Boolean(assetsItems.showManagedDevices),
          path: shiOneUrl.assets.managedAssets.root,
        },
        {
          id: "assets-integration-center",
          type: "Link",
          displayName: "Integration Center",
          visible:
            assetsItems.showWarehouseStock || assetsItems.showWarehouseOrders,
          path: assetsIntegrationCenter,
        },
        {
          id: "assets-cisco-install-base",
          type: "Link",
          displayName: "Cisco Install Base Analysis",
          visible: Boolean(assetsItems.showCiscoInstallBaseAnalysis),
          icon: undefined,
          path: assetsCiscoInstallBaseAnalysis,
        },
      ],
    },
  ];
}
